<template>
    <div>
        <modal :show.sync="show">
            <div class="modal-header"
                 slot="modal-header">
                <h4>Enregistrer un échange</h4>
            </div>

            <div class="modal-body"
                 slot="modal-body">
                <h4>Contacts</h4>

                <div class="row">
                    <div v-for="contact in client.contacts"
                         class="col-sm-6">
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <label>
                                    <input type="checkbox"
                                           v-model="contacts"
                                           :value="contact.id"/>
                                    {{ contact.title | shortTitle }}
                                    {{ contact.first_name }}
                                    {{ contact.last_name }}
                                </label>
                            </div>
                            <div class="panel-body"
                                 v-if="contacts.indexOf(contact.id) >= 0">
                                <div>
                                    <label>
                                        <input type="radio"
                                               :value="-1"
                                               v-model="contactModes[contact.id]"
                                               name="contact-info-{{ contact.id }}"/>
                                        Face-à-face/autre
                                    </label>
                                </div>
                                <div v-for="info in contact.info">
                                    <label>
                                        <input type="radio"
                                               :value="info.id"
                                               v-model="contactModes[contact.id]"
                                               name="contact-info-{{ contact.id }}"/>

                                        <span v-if="info.type === 'email'">
                                            {{ info.value }}
                                        </span>

                                        <span v-if="info.type === 'phone'">
                                            {{ info.value | phone }}
                                        </span>

                                        <div v-if="info.type === 'address'"
                                             class="inline-address">
                                            {{{ info.value | address }}}
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <h4>Contrats</h4>

                <div v-for="contract in contracts">
                    <label>
                        <input type="checkbox"
                               v-model="chosenContracts"
                               :value="contract.id"/>
                        #{{ contract.id }}
                        ({{{ contract.wire_initial | money }}}
                        / {{{ contract.wire_monthly | money }}})
                    </label>
                </div>

                <h4>Honoraires</h4>

                <div class="input-group">
                    <input type="number"
                           step="0.01"
                           v-model="fee"
                           class="form-control">
                    <span class="input-group-addon">€</span>
                </div>

                <h4>Description</h4>

                <div class="form-group">
                    <label for="exchange-summary">Résumé</label>
                    <input type="text"
                           v-model="summary"
                           class="form-control"
                           id="exchange-summary"/>
                </div>

                <div class="form-group">
                    <label for="exchange-description">Description</label>
                    <textarea id="exchange-description"
                              class="form-control"
                              v-model="description"
                              rows="10"></textarea>
                </div>

                <h4 v-if="docs.length">Documents</h4>

                <div v-for="document in docs">
                    <label>
                        <input type="checkbox"
                               v-model="chosenDocuments"
                               :value="document.id"/>
                        {{ document.file.content | filename }}
                    </label>
                </div>
            </div>

            <div slot="modal-footer" class="modal-footer cta">
                <a class="btn btn-default"
                   @click.prevent="show = false">
                    Annuler
                </a>
                <a class="btn btn-primary"
                   :class="{disabled: !valid}"
                   @click.prevent="save">
                    <loader v-if="loading" :inline="true"></loader>
                    Sauvegarder
                </a>
            </div>
        </modal>
    </div>
</template>

<style scoped>
    .inline-address {
        display: inline-block;
        vertical-align: text-top;
    }
</style>

<script type="text/ecmascript-6">
    import Loader from '../../components/Loader';
    import Modal from 'vue-strap/src/Modal';
    import {asyncAction} from '../../utils';
    import {create} from '../../api/exchanges';
    import {list as listContracts} from '../../api/contract';

    export default {
        components: {
            Loader,
            Modal
        },
        props: {
            client: {
                required: true
            },
            contracts: {
                required: true,
                bothWays: true
            }
        },
        data() {
            return {
                docs: [],
                show: false,
                loading: false,
                contacts: [],
                contactModes: {},
                chosenContracts: [],
                summary: '',
                description: '',
                chosenDocuments: [],
                fee: '0'
            };
        },
        computed: {
            /**
             * That's the fee string parsed as float. If NaN is returned, then
             * the input is not valid.
             */
            parsedFee() {
                let fee = this.fee;
                fee = fee.replace(/\s+/, '');
                fee = fee.replace(',', '.');
                return parseFloat(fee);
            },

            valid() {
                if (!this.summary) {
                    return false;
                }

                if (isNaN(this.parsedFee)) {
                    return false;
                }

                return this.contacts.length > 0;
            }
        },
        methods: {
            makeExchange() {
                return {
                    client: this.client.id,
                    contacts: this.contacts,
                    contacts_info: this.contacts
                        .map((c) => this.contactModes[c])
                        .filter((i) => i >= 0),
                    contracts: this.chosenContracts,
                    documents: this.chosenDocuments,
                    summary: this.summary,
                    description: this.description,
                    fee: this.parsedFee
                };
            },
            save: asyncAction('loading', async function () {
                if (!this.valid) {
                    return;
                }

                await create(this.makeExchange());
                this.contracts = await listContracts(this.client.id);
                this.show = false;
            })
        },
        events: {
            'client-add-exchange': function (docs) {
                this.docs = docs;
                this.show = true;

                this.client.contacts.forEach((contact) => {
                    this.contactModes[contact.id] = -1;
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ExchangeModal.vue?94d13c84